import React, {memo} from 'react'
import cx from 'classnames'

/* Components */
import Rating from '../../../../components/Rating/Rating'

/* Styles */
import s from './product-card.scss'

const ProductRating = memo(({rating, ratingCount, stockCount, isProduct, outOfStock}) => {
  const isRatingShown = ratingCount > 0 && rating > 0 && isProduct
  return (
    <div className={s.rating} aria-hidden='true'>
      {isRatingShown && <Rating count={ratingCount} rate={rating} className={'medium'} />}
      {!outOfStock && stockCount > 0 && (
        <span className={isRatingShown ? s.stock : cx(s.stock, s['stock-withoutMargin'])}>
          Stok: {stockCount}
        </span>
      )}
    </div>
  )
})

export default ProductRating
